import { render, staticRenderFns } from "./TableKitchenSink.vue?vue&type=template&id=167816cc&"
import script from "./TableKitchenSink.vue?vue&type=script&lang=js&"
export * from "./TableKitchenSink.vue?vue&type=script&lang=js&"
import style0 from "./TableKitchenSink.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports